import CarouselInstructions from './CarouselInstructions';

export default CarouselInstructions;
